// src/pages/Reports/ReportDashboard.jsx
import React, { useState, useEffect } from "react";
import { Tabs, Card, Row, Col, Typography, Collapse, Input } from "antd";
import {
  StarFilled,
  StarOutlined,
  FolderOpenOutlined,
  BarChartOutlined,
  DollarOutlined,
  CalculatorOutlined,
  PieChartOutlined,
  TeamOutlined,
  SearchOutlined,
  StarTwoTone,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { accessChecker } from "../../lib/functions";
import "./reportDashboard.css";
import { useSelector } from "react-redux";

const { Title } = Typography;
const { Panel } = Collapse;

const groupIcons = {
  salesAndCustomer: <TeamOutlined style={{ color: "#1677ff" }} />,
  expenseAndSupplier: <DollarOutlined style={{ color: "#52c41a" }} />,
  forMyAccountant: <CalculatorOutlined style={{ color: "#fa8c16" }} />,
  businessOverView: <BarChartOutlined style={{ color: "#722ed1" }} />,
  payroll: <PieChartOutlined style={{ color: "#eb2f96" }} />,
  salesTax: <FolderOpenOutlined style={{ color: "#13c2c2" }} />,
};

// ✅ full menuData from your earlier code
const menuData = [
  {
    key: "salesAndCustomer",
    label: "Sales & Customer Reports",
    children: [
      { key: "debtor_balance", label: "Customer Due Balance Report", link: "/reports/debitors-balance" },
      { key: "debtor_balance_invoice_report", label: "Customer Due Balance Invoice Wise Report", link: "/reports/debitors-report-due" },
      // { key: "debtor_ledger", label: "Customer Ledger", link: "/reports/debitor-balance-ledger" },
      { key: "collection_record", label: "Sales & Previous Collection Record", link: "/reports/collection-record" },
      { key: "debtor_receipt_record", label: "Customer Receipt Record", link: "/reports/debtor-receipt-record" },
      { key: "emi_due_list", label: "Customer EMI Due List", link: "/reports/emi-due-list" },
      { key: "advance_debtor_balance", label: "Advance Customer Balance", link: "/reports/advance-debtor-balance" },
      // { key: "sales_ledger", label: "Sales Account Ledger", link: "/reports/sales-ledger" },
      // { key: "sales_return_ledger", label: "Sales Return Account Ledger", link: "/reports/sales-return-ledger" },
      { key: "sales_record_report", label: "Sales Record", link: "/reports/sales-record" },
      { key: "sales_return_record_report", label: "Sales Return Record", link: "/reports/sales-return-record" },
      { key: "ageing_report", label: "Customer/Supplier Ageing Report", link: "/reports/ageing-report" },
      // { key: "product_replace_record_report", label: "Sales Replace Record", link: "/reports/sales-replace-record" },
    ],
  },
  {
    key: "expenseAndSupplier",
    label: "Expense & Supplier Reports",
    children: [
      { key: "creditor_balance", label: "Supplier Due Balance Report", link: "/reports/creditors-balance" },
      { key: "supplier_wise_outflow", label: "Cash Flow Actual and Projection", link: "/reports/supplier-wise-outflow" },
      // { key: "creditor_ledger", label: "Supplier Ledger", link: "/reports/creditor-balance-ledger" },
      { key: "indirect_expense_balance", label: "Expense Balance Report", link: "/reports/indirect-expenses-balance" },
      { key: "expense_record", label: "Expense Record", link: "/reports/expense-record" },
      { key: "advance_creditor_balance", label: "Advance Supplier Balance", link: "/reports/advance-creditor-balance" },
      { key: "creditor_payment_record", label: "Supplier Payment Record", link: "/reports/creditor-payment-record" },
      { key: "expense_recognition_record", label: "Expense Recognition Record", link: "/reports/expense-recognition-record" },
      { key: "direct_expense_balance", label: "Direct Expense Balance", link: "/reports/direct-expense-balance" },
      // { key: "direct_expense_ledger", label: "Direct Expense Account Ledger", link: "/reports/direct-expense-ledger" },
      // { key: "indirect_expense_ledger", label: "Indirect Expense Account Ledger", link: "/reports/indirect-expense-ledger" },
      { key: "purchase_record_report", label: "Purchase Record", link: "/reports/purchase-record" },
      // { key: "purchase_ledger", label: "Purchase Account Ledger", link: "/reports/purchase-ledger" },
      { key: "purchase_return_record_report", label: "Purchase Return Record", link: "/reports/purchase-return-record" },
      // { key: "purchase_return_ledger", label: "Purchase Return Account Ledger", link: "/reports/purchase-return-ledger" },
    ],
  },
  {
    key: "forMyAccountant",
    label: "For My Accountant",
    children: [
       {
        key: "account_transaction_report",
        label: "Account Transaction Report",
        link: "/reports/account-transaction-report",
      },
      {
        key: "cash_bank_balance",
        label: "Cash & Bank Balance Report",
        link: "/reports/account-balance",
      },
      {
        key: "outstanding_pdc_report",
        label: "Daily Cash Flow",
        link: "/reports/outstanding-pdc",
      },
      // {
      //   key: "cash_bank_ledger",
      //   label: "Cash & Bank Account Ledger",
      //   link: "/reports/account-ledger",
      // },
      {
        key: "daily_ledger",
        label: "Day Book",
        link: "/reports/daily-ledger",
      },
      {
        key: "profit_loss",
        label: "Profit Loss Report",
        link: "/reports/profit-loss",
      },
      {
        key: "loan_balance",
        label: "Loan Balance Report",
        link: "/reports/loan-balance",
      },
      // {
      //   key: "loan_ledger",
      //   label: "Loan Account Ledger",
      //   link: "/reports/loan-ledger",
      // },
      {
        key: "balance_sheet",
        label: "Balance Sheet",
        link: "/reports/balance-sheet",
      },
      {
        key: "trial_balance",
        label: "Trial Balance",
        link: "/reports/trial-balance",
      },
      {
        key: "branch_tran_transfer_list",
        label: "Branch Transaction Transfer List",
        link: "/reports/branch-tran-transfer-list",
      },
      {
        key: "indirect_income_balance",
        label: "Indirect Income Accounts Balance",
        link: "/reports/indirect-income-balance",
      },
      // {
      //   key: "indirect_income_ledger",
      //   label: "Indirect Income Account Ledger",
      //   link: "/reports/indirect-income-ledger",
      // },
      {
        key: "direct_income_balance",
        label: "Direct Income Account Balance",
        link: "/reports/direct-income-balance",
      },
      // {
      //   key: "direct_income_ledger",
      //   label: "Direct Income Account Ledger",
      //   link: "/reports/direct-income-ledger",
      // },
      {
        key: "branch_tran_pen_list",
        label: "Branch Transaction Pending List",
        link: "/reports/branch-tran-pending-list",
      },
      {
        key: "branch_tran_rcv_list",
        label: "Branch Transaction Received List",
        link: "/reports/branch-tran-receive-list",
      },
      {
        key: "branch_tran_transaction_inward",
        label: "Branch Transaction Inward",
        link: "/reports/branch-inward",
      },
      {
        key: "branch_tran_transaction_outward",
        label: "Branch Transaction Outward",
        link: "/reports/branch-tran-outward",
      },
      {
        key: "branch_balance",
        label: "Branch Balance Report",
        link: "/reports/branch-balance-report",
      },
      // {
      //   key: "branch_ledger",
      //   label: "Branch Ledger",
      //   link: "/reports/branch-ledger",
      // },
      {
        key: "capital_balance",
        label: "Capital Accounts Balance",
        link: "/reports/capitals-balance",
      },
      // {
      //   key: "capital_ledger",
      //   label: "Capital Account Ledger",
      //   link: "/reports/capital-ledger",
      // },
      // {
      //   key: "service_expense_ledger",
      //   label: "Service Expense Account Ledger",
      //   link: "/reports/service-expense-ledger",
      // },
      // {
      //   key: "service_ledger",
      //   label: "Service Account Ledger",
      //   link: "/reports/service-ledger",
      // },
      {
        key: "income_record",
        label: "Income Record",
        link: "/reports/income-record",
      },
      {
        key: "journal_record",
        label: "Journal Record",
        link: "/reports/journal-record",
      },
      {
        key: "contra_record",
        label: "Contra Record",
        link: "/reports/contra-record",
      },
      {
        key: "investment_balance",
        label: "Investment Balance",
        link: "/reports/investment-balance",
      },
      // {
      //   key: "investment_ledger",
      //   label: "Investment Ledger",
      //   link: "/reports/investment-ledger",
      // },
      {
        key: "deposit_account_report",
        label: "Deposit Account Balance",
        link: "/reports/deposit-account-report",
      },
      // {
      //   key: "deposit_account_ledger",
      //   label: "Deposit Account Ledger",
      //   link: "/reports/deposit-account-ledger",
      // },
      {
        key: "current_liability",
        label: "Current Liablity Report",
        link: "/reports/current-liablity-report",
      },
      // {
      //   key: "current_liability_ledger",
      //   label: "Current Liablity Ledger",
      //   link: "/reports/current-liability-ledger",
      // },
      {
        key: "suspense_balance",
        label: "Suspense Balance Report",
        link: "/reports/suspense-balance",
      },

      // {
      //   key: "suspense_ledger",
      //   label: "Suspense Ledger",
      //   link: "/reports/suspense-ledger",
      // },
      {
        key: "reserve_surplus",
        label: "Reserve Surplus Report",
        link: "/reports/reserve-surplus-balance",
      },
      // {
      //   key: "reserve_surplus_ledger",
      //   label: "Reserve Surplus Ledger",
      //   link: "/reports/reserve-surplus-ledger",
      // },
      // {
      //   key: "intangible_asset_ledger",
      //   label: "Intangible Asset Ledger",
      //   link: "/reports/intangible-asset-ledger",
      // },
      {
        key: "intangible_asset",
        label: "Intangible Asset",
        link: "/reports/intangible-asset",
      },
     
    ],
  },
  {
    key: "businessOverView",
    label: "Business Overview",
    children: [
      {
        key: "item_stock_in_report",
        label: "Item Stock Report",
        link: "/reports/item-stock-report",
      },
      {
        key: "item_wise_profit_loss",
        label: "Item Profit/Loss Report",
        link: "/reports/item-wise-profit",
      },
      {
        key: "bill_wise_profit_loss",
        label: "Bill Wise Profit Loss Report",
        link: "/reports/bill-wise-profit-loss",
      },
      {
        key: "fixed_asset_balance",
        label: "Fixed Asset Accounts Balance",
        link: "/reports/fixed-asset-balance",
      },
      // {
      //   key: "fixed_asset_ledger",
      //   label: "Fixed Asset Account Ledger",
      //   link: "/reports/fixed-asset-ledger",
      // },
      {
        key: "production_record_report",
        label: "Manufacturing Record",
        link: "/reports/manufacturing-record",
      },
      {
        key: "current_assets_balance",
        label: "Current Asset Accounts Balance",
        link: "/reports/current-assets-report",
      },
      // {
      //   key: "current_assets_ledger",
      //   label: "Current Asset Accounts Ledger",
      //   link: "/reports/current-asset-ledger",
      // },
    ],
  },
  {
    key: "payroll",
    label: "Payroll",
    children: [
      {
        key: "salary_in_report",
        label: "Salary Payment Report",
        link: "/reports/salary-report",
      },
      {
        key: "monthly_salary_in_report",
        label: "Monthly Salary Report",
        link: "/reports/monthly-salary-report",
      },
    ],
  },
  {
    key: "salesTax",
    label: "Sales Tax",
    children: [
      // {
      //   key: "tax_ledger",
      //   label: "Tax Account Ledger",
      //   link: "/reports/tax-ledger",
      // },
      {
        key: "sales_return_gstr1",
        label: "Sales Return GSTR 1",
        link: "/reports/gstreturns",
        requiresGST: true,
      },
      {
        key: "purchase_return_gstr2",
        label: "Purchase Return GSTR 2",
        link: "/reports/purchase-gstreturns",
        requiresGST: true,
      },
      {
        key: "gstr_3b_summary",
        label: "GSTR-3B Summary",
        link: "/reports/gstr-3b-summary",
        requiresGST: true,
      },
    ],
  },
];

const ReportDashboard = () => {
  const [favourites, setFavourites] = useState(() => {
    return JSON.parse(localStorage.getItem("report_favs") || "[]");
  });
  const [searchTerm, setSearchTerm] = useState("");

  const authInfo = useSelector((state) => state.auth.auth_info);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const isGstEnabled = authInfo?.gst_enabled === "yes";

  const showGST = isIndia && isGstEnabled;

  useEffect(() => {
    localStorage.setItem("report_favs", JSON.stringify(favourites));
  }, [favourites]);

  const toggleFavourite = (key) => {
    setFavourites((prev) =>
      prev.includes(key) ? prev.filter((f) => f !== key) : [...prev, key]
    );
  };

  // ✅ filter menuData by access and search
  // const filteredMenuData = menuData.map((group) => {
  //   if (group.children) {
  //     const filteredChildren = group.children.filter(
  //       (child) =>
  //         accessChecker(child.key) &&
  //         child.label.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //     return { ...group, children: filteredChildren };
  //   }
  //   return group;
  // });

  const filteredMenuData = menuData.map((group) => {
    if (group.children) {
      const filteredChildren = group.children.filter((child) => {
        const hasAccess = accessChecker(child.key);

        const gstAllowed = child.requiresGST
          ? showGST
          : true;

        const matchesSearch = child.label
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

        return hasAccess && gstAllowed && matchesSearch;
      });

      return { ...group, children: filteredChildren };
    }
    return group;
  });

  const renderCards = (items) => (
    <Row gutter={[16, 16]}>
      {items.map((item) => (
        <Col xs={24} sm={12} md={12} lg={12} xl={6} key={item.key}>
          <Card className="reportCard" hoverable>
            <div className="cardContent">
              <div className="labelWrap">
                <Link to={item.link}>{item.label}</Link>
              </div>
              {favourites.includes(item.key) ? (
                <StarFilled
                  className="favIcon favActive"
                  onClick={() => toggleFavourite(item.key)}
                />
              ) : (
                <StarOutlined
                  className="favIcon"
                  onClick={() => toggleFavourite(item.key)}
                />
              )}
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );

  return (
    <div className="reportDashboard">
      <div className="dashboardHeader">
        <Title level={3}>
          <BarChartOutlined style={{ marginRight: 8, color: "#1677ff" }} />
          Reports Dashboard
        </Title>
        <Input
          placeholder="Search reports..."
          prefix={<SearchOutlined />}
          allowClear
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="searchInput"
        />
      </div>

      <Tabs
        defaultActiveKey="standard"
        items={[
          {
            key: "standard",
            label: "Standard",
            children: (
              <Collapse
                accordion
                bordered={false}
                className="reportCollapse"
                items={filteredMenuData
                  .filter((group) => group.children && group.children.length > 0)
                  .map((group) => ({
                    key: group.key,
                    label: (
                      <span className="groupTitle">
                        {groupIcons[group.key] || <FolderOpenOutlined />} {group.label}
                      </span>
                    ),
                    children: renderCards(group.children),
                  }))}
              />
            ),
          },
          {
            key: "favourites",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <StarFilled style={{ color: "#faad14" }} />
                Favourites
              </span>
            ),

            children: (
              <Collapse
                accordion
                bordered={false}
                className="reportCollapse"
                items={filteredMenuData
                  .map((group) => ({
                    ...group,
                    children: group.children.filter((c) =>
                      favourites.includes(c.key)
                    ),
                  }))
                  .filter((group) => group.children && group.children.length > 0)
                  .map((group) => ({
                    key: group.key,
                    label: (
                      <span className="groupTitle">
                        {groupIcons[group.key] || <FolderOpenOutlined />} {group.label}
                      </span>
                    ),
                    children: renderCards(group.children),
                  }))}
              />
            ),
          },
        ]}
      />


    </div>
  );
};

export default ReportDashboard;
